import React from "react"
import PropTypes from "prop-types"

import BtnPrimary from '../form_sections/BtnPrimary'
import TopicTags from './TopicTags'

class TopicForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedTags: [],
      tags: [],
      loading: false,
      title: '',
      body: '',
      titleError: '',
      bodyError: '',
      tagsError: '',
      successForm: false,
    }
    this.onSubmitForm = this.onSubmitForm.bind(this)
    this.updateSelectedTags = this.updateSelectedTags.bind(this)
    this.onChangeTitle = this.onChangeTitle.bind(this)
    this.onChangeBody = this.onChangeBody.bind(this)
  }

  updateSelectedTags(n) {
    if(this.state.selectedTags.includes(n)) {
      let newSelectedLevels = this.state.selectedTags.filter(function(e) { return e !== n })
      this.setState({
        selectedTags: newSelectedLevels
      })
    } else {

      let selectedTags = this.state.selectedTags
      let newSelectedLevels = selectedTags.concat(n)
      this.setState({
        selectedTags: newSelectedLevels,
        tagsError: ''
      })
    }
  }

  onSubmitForm() {
    this.setState({
      loading: true,
      tagsError: '',
      titleError: '',
      bodyError: ''
    })
    if(this.state.selectedTags.length === 0) {
      this.setState({
        loading: false,
        tagsError: 'Select at least 1 tag'
      })
    } else if (this.state.title.length < 5) {
      if(this.state.title.length === 0) {
        this.setState({
          loading: false,
          titleError: 'Create a title for the activity'
        })
      } else {
        this.setState({
          loading: false,
          titleError: 'Create a longer title'
        })
      }

    } else if (this.state.body.length < 15) {
      if(this.state.body.length === 0) {
        this.setState({
          loading: false,
          bodyError: 'How do you practice this activity? Try giving examples of how to do the activity.'
        })
      } else {
        this.setState({
          loading: false,
          bodyError: 'Activity is too short. Try giving examples of how to do the activity.'
        })
      }
    } else {
      $.ajax({
        url: `../new_api_exchange`,
        dataType: 'JSON',
        type: 'POST',
        data: {
          tags: this.state.selectedTags,
          title: this.state.title,
          body: this.state.body,
        },
        header: {
          'Content-Type': 'application/json'
        },
        success: () => {
          this.setState({
            successForm: true,
            selectedTags: []
          })
        },
        error: function(xhr, status, err) {
          console.log(err)
        }.bind(this)
      });
    }
  }


  componentDidMount() {
    this.setState({
      tags: this.props.tags
    })
  }

  onChangeTitle(event) {
      this.setState({
        title: event.target.value,
        titleError: ''
      })
  }

  onChangeBody(event) {
    this.setState({
      body: event.target.value,
      bodyError: ''
    })
  }

  render() {
    if(this.state.successForm) {
      return(
        <div className="form_wrapper">
          <h4 className="form_title">Success!</h4>
          <br />
          <h4 style={{textAlign: 'center', color: 'white'}}>Lexody will review the activity, and then it will be live for others to use</h4>
          <br />
          <br/>
          <br />
          <BtnPrimary onClick={() => this.setState({successForm: false, loading: false, buttonText:"Sumbit", selectedTags: []})} buttonText="Create Another Topic" loaderLottie={this.props.loaderLottie} loading={false} />
        </div>
      )
    } else {
      return(
        <div>
          <div className="form_wrapper">
            <h4 className="form_title">New Lex Activity</h4>

            <p className="input_title">Title</p>
            {this.state.titleError.length > 0 && <p className="input_error">{this.state.titleError}</p>}
            <input onChange={this.onChangeTitle} id="title" className="form_input" placeholder="Example: Vacation and Past Tense" />

            <p className="input_title">How to do the activity</p>
            {this.state.bodyError.length > 0 && <p className="input_error">{this.state.bodyError}</p>}
            <textarea
              onChange={this.onChangeBody}
              id="body"
              rows="10"
              className="form_input"
              placeholder="Example:Talk about your last vacation.&#13;&#10;Where did you go? Who were you with?"/>

            <p className="input_title">Tags</p>
            <p className="input_instructions" style={{marginBottom: 12}} >Select all that apply</p>
            {this.state.tagsError.length > 0 && <p className="input_error">{this.state.tagsError}</p>}

          </div>
            <TopicTags tags={this.state.tags} selectedTags={this.state.selectedTags} updateSelectedTags={this.updateSelectedTags}/>
          <div className="form_wrapper">
            <BtnPrimary onClick={this.onSubmitForm} buttonText="Submit" loaderLottie={this.props.loaderLottie} loading={this.state.loading} />
            <p className="input_instructions" style={{marginTop: 12}} >After submitting, Lexody’s team will review before the activity is live.</p>
          </div>
        </div>
      )
    }
  }

}

export default TopicForm;
